import { Box, Container, Grid, Link, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { API } from '../../../global/config/api';
import { useServerCall } from '../../../global/helpers/hooks';
import { BaseHeader, XsButton } from '../../../global/ui';

function MainContainer() {
  const { t } = useTranslation();
  const history = useHistory();

  // fire-and-forget: načíta appInfo (maintenance flag, recaptcha info, ...)
  useServerCall<undefined, any>({
    key: 'main_appInfo',
    mode: 'auto',
    request: { method: 'GET', url: API.appInfo() },
    disableServerError: true,
    queryOptions: { refetchOnWindowFocus: false }
  });

  return (
    <>
      <BaseHeader />
      <Container maxWidth='md'>
        <Grid container direction='column' spacing={8}>
          <Grid item>
            <Box pt={8}>
              <Typography variant='h3'>{t('main.title')}</Typography>
            </Box>
          </Grid>

          {/* Registrácia */}
          <Grid item container direction='column' spacing={4}>
            <Grid item>
              <XsButton fullWidth={false} label='main.register_button' onClick={() => history.push('/register')} />
            </Grid>
            <Grid item>
              <Typography variant='body2'>{t('main.register_desc')}</Typography>
            </Grid>
          </Grid>

          {/* Prihlásenie */}
          <Grid item container direction='column' spacing={4}>
            <Grid item>
              <XsButton fullWidth={false} label='main.login_button' onClick={() => history.push('/login')} />
            </Grid>
            <Grid item>
              <Typography variant='body2'>{t('main.login_desc')}</Typography>
            </Grid>
          </Grid>

          {/* Poradovník žiadostí */}
          <Grid item container direction='column' spacing={4}>
            <Grid item>
              <XsButton fullWidth={false} label='main.waiting_button' onClick={() => history.push('/waiting')} />
            </Grid>
            <Grid item>
              <Typography variant='body2'>{t('main.waiting_desc')}</Typography>
            </Grid>
          </Grid>

          {/* Info box – zrušenie registrácie */}
          <Grid item container direction='column' spacing={1} style={{ marginTop: '16px' }}>
            <div style={{ border: '1px solid #b6b6b6', borderRadius: '12px', padding: '16px' }}>
              <Grid item>
                <Box>
                  <Typography variant='body2' style={{ fontWeight: 'bold' }}>
                    {t('main.cancel_registration_title')}
                  </Typography>
                </Box>
              </Grid>
              <Grid item>
                <Typography variant='body2'>{t('main.cancel_registration_1')}</Typography>
              </Grid>
              <Grid item>
                <Typography variant='body2'>
                  {t('main.cancel_registration_2_prefix')}{' '}
                  <Link className='pointer' onClick={() => window.open('mailto:zelenapodnikom@siea.gov.sk')}>
                    zelenapodnikom@siea.gov.sk
                  </Link>
                  {t('main.cancel_registration_2_suffix')}
                </Typography>
              </Grid>
              <Grid item>
                <Typography variant='body2'>
                  {t('main.cancel_registration_3_prefix')}{' '}
                  <Link className='pointer' onClick={() => window.open('mailto:zelenapodnikom@siea.gov.sk')}>
                    zelenapodnikom@siea.gov.sk
                  </Link>
                  {t('main.cancel_registration_3_suffix')}
                </Typography>
              </Grid>
              <Grid item>
                <Typography variant='body2'>{t('main.cancel_registration_condition')}</Typography>
              </Grid>
            </div>
          </Grid>
        </Grid>
      </Container>
    </>
  );
}

export default observer(MainContainer);
